import React from "react";
import classNames from "classnames";
import { Overlay, Wrapper } from "./styles";
import { variantLoader } from "components/PopUpManager/variant-loader";
import { LeftRightAnimation } from "theme/animations";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useBreakpoints from "hooks/useBreakpoints";
import { useAppDispatch } from "hooks";
import { onClosePopUpV2 } from "redux/slices/pop-up-manager-v2";
import { ManagedPopUp } from "redux/slices/pop-up-manager-v2/types";
import { isScalableVariant } from "../helpers/isScalableVariant";

export interface PopUpShellProps {
	popup: ManagedPopUp;
	index: number;
	isTop: boolean;
}

export const PopUpShell: React.FC<PopUpShellProps> = ({
	popup,
	index,
	isTop
}) => {
	const dispatch = useAppDispatch();
	const { isSmDown } = useBreakpoints();
	const scalable = isScalableVariant(popup.variant);
	// Only top popup darkens & captures clicks; others transparent & pass-through
	const backdropOpacity = isTop ? 0.6 : 0; // adjust desired darkness
	const pointerEvents = isTop ? "auto" : "none";
	return (
		<Overlay
			className={classNames(
				scalable && "scale",
				popup.variant === "tutorial" && "tutorial"
			)}
			style={{
				// Ensure V2 popups sit above DIP (9999) and v1 popups (9998)
				zIndex: 10000 + index,
				backgroundColor: `rgba(0,0,0,${backdropOpacity})`,
				pointerEvents
			}}
			data-popup-id={popup.id}
		>
			<LeftRightAnimation enabled={!popup.variant.includes("tutorial")}>
				<Wrapper className={classNames(isSmDown && "mobile")}>
					{variantLoader(popup.variant)}
					{!scalable && (
						<CloseIconButton
							onClose={() => dispatch(onClosePopUpV2({ id: popup.id }))}
						/>
					)}
				</Wrapper>
			</LeftRightAnimation>
		</Overlay>
	);
};

export default PopUpShell;
